import React from 'react'
import {
    Link
} from "react-router-dom";
import logo from '../img/logo-black.png';
import '../css/Navbar.css'
import { useState } from 'react';

export default function Navbar() {

    // State to manage the navbar's collapse state
    const [expanded, setExpanded] = useState(false);

    // Function to close the navbar when a link is clicked
    const closeNavbar = () => setExpanded(false);

    return (
        <>
            <nav className="navbar navbar-expand-lg bg-black px-lg-6" expanded={expanded.toString()}>
                <div className="container-fluid">
                    <Link className="navbar-brand" to="/">
                        <img src={logo} alt="Logo" width="auto" height="50" className="d-inline-block align-text-top" />
                    </Link>
                    <button
                        className="navbar-toggler bg-grey"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNavDropdown"
                        aria-controls="navbarNavDropdown"
                        aria-expanded={expanded}
                        aria-label="Toggle navigation"
                        onClick={() => setExpanded(!expanded)}
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className={`collapse navbar-collapse ${expanded ? 'show' : ''}`} id="navbarNavDropdown">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0 navCenter">
                            <li>
                                <Link className="nav-item nav-link bg-blue" to="/" onClick={closeNavbar}>HEM</Link>
                            </li>
                            <li>
                                <Link className="nav-item nav-link bg-blue" to="/om-oss" onClick={closeNavbar}>OM OSS</Link>
                            </li>
                            <li>
                                <Link className="nav-item nav-link bg-blue" to="/referenser" onClick={closeNavbar}>REFERENSER</Link>
                            </li>
                            <li>
                                <Link className="nav-item nav-link bg-blue" to="/tjänster" onClick={closeNavbar}>TJÄNSTER</Link>
                            </li>
                            <li>
                                <Link className="nav-item nav-link bg-blue" to="/kontakt" onClick={closeNavbar}>KONTAKT</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}